import Home from "./Components/Home/Home";
import "./App.css";
import Features from "./Components/Features/Features";
function App() {
  return (
    <div className="App">
      <Home />
      <Features />
    </div>
  );
}

export default App;
